module.exports = __webpack_public_path__ + "img/micro_typon.a909540e.png";